import { render } from "./AudioVisual.vue?vue&type=template&id=1ae25035&scoped=true"
import script from "./AudioVisual.vue?vue&type=script&lang=js"
export * from "./AudioVisual.vue?vue&type=script&lang=js"

import "./AudioVisual.vue?vue&type=style&index=0&id=1ae25035&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae25035"]])

export default __exports__